import { request } from "./client";

export type WorkflowNode = {
  id: string;
  agent: string;
  task: string;
  next: string[];
};

export type WorkflowGraph = {
  id: string;
  entry: string;
  nodes: Record<string, WorkflowNode>;
  edges?: { from: string; to: string }[];
  owner_user_id?: string | null;
  owner_org_id?: string | null;
  allowed_roles?: string[];
};

export async function listWorkflows(): Promise<WorkflowGraph[]> {
  const payload = await request<{ workflows: WorkflowGraph[] }>("/workflows");
  return payload?.workflows ?? [];
}

export async function getWorkflow(workflowId: string): Promise<WorkflowGraph> {
  return request<WorkflowGraph>(`/workflows/${encodeURIComponent(workflowId)}`);
}

export async function createWorkflow(graph: WorkflowGraph): Promise<WorkflowGraph> {
  return request<WorkflowGraph>("/workflows", {
    method: "POST",
    body: graph,
  });
}

export async function updateWorkflow(graph: WorkflowGraph): Promise<WorkflowGraph> {
  return request<WorkflowGraph>(`/workflows/${encodeURIComponent(graph.id)}`, {
    method: "PUT",
    body: graph,
  });
}

export async function deleteWorkflow(workflowId: string): Promise<void> {
  await request(`/workflows/${encodeURIComponent(workflowId)}`, { method: "DELETE" });
}
